import { memo, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
// Import Store
import { useAppSelector } from 'store';
import { selectUserId } from 'store/slices/userData';

interface Props {
    isReady: boolean;
}

const BMENewsModal: React.FC<Props> = ({ isReady }) => {
    const UserId = useAppSelector(selectUserId);
    const [isInitiated, setIsInitiated] = useState(false);

    useEffect(() => {
        if (isReady) {
            setIsInitiated(true);
        }
    }, [isInitiated, isReady]);

    const scriptOnLoad = (userId) => {
        if ((window as AnyObject).NewsModalBC && !process.env.REACT_APP_IGNORE_NEWS_MODAL) {
            (window as AnyObject).NewsModalBC.init({
                env: process.env.REACT_APP_BME_NEWS,
                token: process.env.REACT_APP_BME_NEWS_TOKEN,
                identifier: `${userId}`,
                mainColor: '#2BC784',
            });
        }
    };

    return (
        <>
            {isInitiated && (
                <Helmet>
                    <script
                        async
                        src={process.env.REACT_APP_BME_NEWS_URL}
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        onLoad={`(${scriptOnLoad.toString()})(${UserId})`}
                    ></script>
                </Helmet>
            )}
        </>
    );
};

export default memo(BMENewsModal);
